'use strict';

angular.module('ntmApp').factory('OtherActivitiesViewModel', ['$q', 'DailyPlanService', 'DailyPlanResourcePool', 'FlashService', 'Utils', 'DailyPlanConfirmationService',
                                  'DragStaffIntoResourcePool', 'DraggingToResourcePoolActions', 'DragFromRPToOtherActivities', 'DragActivitySequence', 'Constants', 'NonDailyActivities',
                                  'SignalR', 'ElementIdHelper',
    function ($q, DailyPlanService, DailyPlanResourcePool, FlashService, Utils, DailyPlanConfirmationService,
              DragStaffIntoResourcePool, DraggingToResourcePoolActions, DragFromRPToOtherActivities, DragActivitySequence, Constants, NonDailyActivities,
              SignalR, ElementIdHelper) {

        function OtherActivitiesViewModel(context) {

            var self = this;

            var ConversionFactor = {
                seconds: 1 / 60,
                minutes: 1,
                hours: 60
            };

            self.activityType = Constants.ActivityTypes;

            var FacilityActivityChangedProperty = {
                metricDuration: function (activity, value) {

                    var conversionFactor = ConversionFactor[activity.durationUnit || 'minutes'];
                    if (conversionFactor !== undefined) {
                        activity.totalDuration = parseFloat((parseFloat(value) * activity.quantity * conversionFactor));
                    }
                },
                totalDuration: function (activity, value) {

                    var conversionFactor = ConversionFactor[activity.durationUnit || 'minutes'];

                    if (conversionFactor !== undefined) {
                        activity.metricDuration = activity.quantity > 0 ? parseFloat((parseFloat(value) / (activity.quantity * conversionFactor))) : parseFloat(0);
                    }
                }
            };

            self.showUnplanedActivitiesButton = function (button) {


                if (!button.jsonProperties || !button.jsonProperties.display) {
                    return true;
                }

                return button.jsonProperties.display.level2;
            };

            var AreaActivityChangedProperty = {
                metricDuration: function (activity, value) {

                    var conversionFactor = ConversionFactor[activity.durationUnit || 'minutes'];
                    if (conversionFactor !== undefined) {
                        activity.totalDuration = parseFloat((parseFloat(value) * activity.quantity * conversionFactor));
                    }
                },
                totalDuration: function (activity, value) {

                    var conversionFactor = ConversionFactor[activity.durationUnit || 'minutes'];

                    if (conversionFactor !== undefined) {
                        activity.metricDuration = activity.quantity > 0 ? parseFloat((parseFloat(value) / (activity.quantity * conversionFactor))) : parseFloat(0);
                    }
                }
            };



            self.RowActions = {
                cancelActivity: { value: 1, name: 'Cancel Activity', icon: 'Grid-Setup-Delete-Selectedui-24px-outline.svg' }
            };

            self.load = function (doNotReload) {
                self.isLoading = true;

                loadOtherActivities().then(function () {
                    self.isLoading = false;
                });

                if (!doNotReload) {
                    loadStatistics();
                    self.ResourcePool.load();
                    self.NonDailyActivities.load();
                }
            };

            self.hasOtherActivities = function () {

                if (self.otherActivities) {
                    return ((self.otherActivities.activities && self.otherActivities.activities[0] && self.otherActivities.activities.length > 0));
                }

                return false;
            };

            self.isChanged = function () {
                return self.isActivitiesGridChanged();
            };

            self.toggleStatistics = function () {
                self.showStatistics = !self.showStatistics;
                self.showResourcePool = false;
                self.showNonDailyActivities = false;

                saveRightPanesState();
            };

            self.toggleResourcePool = function () {
                self.showResourcePool = !self.showResourcePool;
                self.showStatistics = false;
                self.showNonDailyActivities = false;

                saveRightPanesState();
            };

            self.toggleNonDailyActivities = function () {
                self.showNonDailyActivities = !self.showNonDailyActivities;
                self.showStatistics = false;
                self.showResourcePool = false;

                saveRightPanesState();
            };

            self.isRightPanelOpened = function () {
                return self.showStatistics || self.showResourcePool || self.showNonDailyActivities;
            };

            self.editOtherActivities = function () {
                setEditMode();
            };

            self.getMetricDurationStepValue = function (durationType, getValueType) {

                var spinerStep = 1;
                var roundTo = 1;

                switch (durationType) {
                    case 'seconds':
                        spinerStep = 1;
                        roundTo = 0;
                        break;
                    case 'minutes':
                        spinerStep = 0.1;
                        roundTo = 2;
                        break;
                    case 'hours':
                        spinerStep = 0.01;
                        roundTo = 2;
                        break;

                }

                if (getValueType === 'roundTo') {
                    return roundTo;
                } else if (getValueType === 'spinerStep') {
                    return spinerStep;
                }
            };

            self.totalFacilityActivityMinutes = function (facilityActivity) {

                if (facilityActivity && facilityActivity.items) {
                    return facilityActivity.items.reduce(function (sum, item) {
                        return (sum || 0) + parseFloat(item.totalDuration) || 0;
                    }, 0);
                }

                return 0;
            };

            self.totalAreaActivityMinutes = function (areaActivity) {

                if (areaActivity && areaActivity.items) {
                    return areaActivity.items.reduce(function (sum, item) {
                        return (sum || 0) + parseFloat(item.totalDuration) || 0;
                    }, 0);
                }

                return 0;
            };

            self.isActivitiesGridChanged = function () {
                return isActivitiesGridChanged();
            };

            self.facilityActivityChanged = function (activity, group, property) {

                if (angular.isNumber(activity.quantity) && angular.isNumber(parseFloat(activity[property]))) {

                    if (FacilityActivityChangedProperty[property]) {
                        FacilityActivityChangedProperty[property](activity, activity[property]);
                    }

                } else {
                    activity.totalDuration = null;
                }

                group.groupingSummaries = getGroupingStaffSummaries(group);
            };

            self.areaActivityChanged = function (activity, group, property) {

                if (angular.isNumber(activity.quantity) && angular.isNumber(parseFloat(activity[property]))) {

                    if (AreaActivityChangedProperty[property]) {
                        AreaActivityChangedProperty[property](activity, activity[property]);
                    }

                } else {
                    activity.totalDuration = null;
                }

                group.groupingSummaries = getGroupingStaffSummaries(group);
            };

            self.updateViewOnWebSocketsResponse = function (callBackData) {

                var dateDisplayed = moment(context.TopBar.dateDisplayed).startOf('day');
                var socketDate = moment(callBackData.date).startOf('day');

                if (dateDisplayed.isSame(socketDate) && !self.EditMode) {

                    if (context.selectedActivityType && context.selectedActivityType === 'Other Activities') {

                        var callbackFacilityMatched = callBackData.dailySocketFacilities.firstOrDefault(function (facility) {
                            return (facility.facilityCode && facility.facilityCode.toString() === context.TopBar.BreadCrumbs.selectedLocation.id.toString());
                        });

                        if (callbackFacilityMatched) {
                            reloadView();
                        }
                    }
                }
            };

            self.confirmViewLeaving = function (nextAction) {

                var saveAndContinue = function () {

                    if (self.EditMode || self.isActivitiesGridChanged()) {
                        self.saveOtherActivities(nextAction);
                    }

                };

                var continueWithoutSaving = function () {

                    if (self.EditMode || self.isActivitiesGridChanged()) {
                        self.cancelOtherActivitiesDurationChanges(nextAction);
                    }

                };

                DailyPlanConfirmationService.Confirmation(getOnLeaveConfirmMessage())
                                   .Yes(saveAndContinue)
                                   .No(continueWithoutSaving)
                                   .Ask();
            };

            self.getInfoForDraggingAction = function () {
                var scheduleIds = [];
                var schedules = [];
                var targetActivitiesInNewStatusList = [];
                var isExistingAssignments = self.ResourcePool.replaceAssignments || false;
                var activities = [];

                if (self.otherActivities.activities.assigneeStatistics.dndTarget && self.otherActivities.activities.assigneeStatistics.dndTarget.length > 0) {
                    scheduleIds = [];
                    schedules = [];
                    activities = [];

                    if (isExistingAssignments) {
                        self.otherActivities.activities.forEach(function (activityGroup) {
                            activityGroup.items.forEach(function (activityItem) {
                                if (self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId)) {
                                    scheduleIds.push(activityItem.scheduleId);
                                    schedules.push(activityItem);
                                    activities.push({ speciesId: activityItem.speciesCode, speciesName: activityItem.speciesName, activityId: activityItem.activityId, activity: activityItem.activity, assignmentId: activityItem.assignmentId, activityStatusId: activityItem.activityStatusId });
                                }
                            });
                        });

                        targetActivitiesInNewStatusList = schedules.filter(function (activityItem) {
                            return self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId);
                        });
                    }
                    else {
                        self.otherActivities.activities.forEach(function (activityGroup) {
                            activityGroup.items.filter(function (activityItem) {
                                return !activityItem.assignmentId;
                            }).forEach(function (activityItem) {
                                if (self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId)) {
                                    scheduleIds.push(activityItem.scheduleId);
                                    schedules.push(activityItem);
                                    activities.push({ speciesId: activityItem.speciesCode, speciesName: activityItem.speciesName, activityId: activityItem.activityId, activity: activityItem.activity, assignmentId: activityItem.assignmentId, activityStatusId: activityItem.activityStatusId });
                                }
                            });
                        });
                    }

                    return {
                        date: moment(context.TopBar.dateDisplayed),
                        scheduleIds: scheduleIds,
                        schedules: schedules,
                        targetActivitiesInNewStatusList: targetActivitiesInNewStatusList.length > 0 ? targetActivitiesInNewStatusList : null,
                        scopeCode: context.TopBar.BreadCrumbs.selectedLocation.id,
                        scopeName: context.TopBar.BreadCrumbs.selectedLocation.name,
                        scopeMode: context.getViewMode(),
                        otherActivityMode: 0,
                        isExistingAssignments: self.ResourcePool.replaceAssignments || false,
                        isLocationActivities: true,
                        activities: activities
                    };
                }

                var activitiesGroup = self.otherActivities.activities.firstOrDefault(function (group) {
                    return group.dndTarget && group.dndTarget.length > 0;
                });

                if (activitiesGroup) {

                    if (isExistingAssignments) {
                        activitiesGroup.items.forEach(function (activityItem) {
                            if (self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId)) {
                                scheduleIds.push(activityItem.scheduleId);
                                schedules.push(activityItem);
                                activities.push({ speciesId: activityItem.speciesCode, speciesName: activityItem.speciesName, activityId: activityItem.activityId, activity: activityItem.activity, assignmentId: activityItem.assignmentId, activityStatusId: activityItem.activityStatusId });
                            }
                        });

                        targetActivitiesInNewStatusList = schedules.filter(function (activityItem) {
                            return self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId);
                        });
                    }
                    else {
                        activitiesGroup.items.filter(function (activityItem) {
                            return !activityItem.assignmentId;
                        }).forEach(function (activityItem) {
                            if (self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId)) {
                                scheduleIds.push(activityItem.scheduleId);
                                schedules.push(activityItem);
                                activities.push({ speciesId: activityItem.speciesCode, speciesName: activityItem.speciesName, activityId: activityItem.activityId, activity: activityItem.activity, assignmentId: activityItem.assignmentId, activityStatusId: activityItem.activityStatusId });
                            }
                        });
                    }

                    return {
                        date: moment(context.TopBar.dateDisplayed),
                        scheduleIds: scheduleIds,
                        schedules: schedules,
                        targetActivitiesInNewStatusList: targetActivitiesInNewStatusList.length > 0 ? targetActivitiesInNewStatusList : null,
                        scopeCode: context.TopBar.BreadCrumbs.selectedLocation.id,
                        scopeName: context.TopBar.BreadCrumbs.selectedLocation.name,
                        scopeMode: context.getViewMode(),
                        otherActivityMode: 1,
                        groupCode: activitiesGroup.id,
                        groupName: activitiesGroup.name,
                        isExistingAssignments: self.ResourcePool.replaceAssignments || false,
                        isActivitiesGroup: true,
                        activities: activities
                    };
                }

                var activitiesGroupWithTargetedActivity = self.otherActivities.activities.firstOrDefault(function (group) {
                    return group.items.some(function (item) {
                        return item.dndTarget && item.dndTarget.length > 0;
                    });
                });

                if (activitiesGroupWithTargetedActivity) {

                    var facilityActivity = activitiesGroupWithTargetedActivity.items.firstOrDefault(function (item) {
                        return item.dndTarget && item.dndTarget.length > 0;
                    });

                    if (facilityActivity) {

                        return {
                            facilityCode: context.TopBar.BreadCrumbs.selectedLocation.id,
                            date: moment(context.TopBar.dateDisplayed),
                            scheduleId: facilityActivity.scheduleId,
                            schedule: facilityActivity,
                            activityName: facilityActivity.activity,
                            totalHoursActivitiesRow: facilityActivity.totalHours,
                            isExistingAssignments: self.ResourcePool.replaceAssignments || false,
                            isSingleActivity: true,
                            speciesId: facilityActivity.speciesCode, speciesName: facilityActivity.speciesName, activityId: facilityActivity.activityId, activity: facilityActivity.activity
                        };
                    }
                }

                return {};
            };

            self.saveOtherActivities = function (nextAction) {

                var request = context.getViewModeSelectedDateAndLocation();
                request.scheduleDurations = [];

                self.otherActivities.activities.forEach(function (facilityActivity) {

                    var originalGroup = self.otherActivitiesOriginal.activities.firstOrDefault(function (original) {
                        return original.name === facilityActivity.name;
                    });

                    if (originalGroup) {

                        facilityActivity.items.forEach(function (item) {

                            var originalActivity = originalGroup.items.firstOrDefault(function (activity) {
                                return item.scheduleId === activity.scheduleId;
                            });

                            if (originalActivity && item.totalDuration !== originalActivity.totalDuration) {

                                request.scheduleDurations.push({
                                    scheduleId: item.scheduleId,
                                    metricDuration: item.metricDuration,
                                    totalMinutes: item.totalDuration
                                });
                            }
                        });
                    }
                });

                var loadingModal = FlashService.Loading();
                DailyPlanService.SaveRoomActivities(request).then(function (result) {

                    if (result.success) {
                        self.otherActivitiesOriginal = angular.copy(self.otherActivities);
                        setViewMode();

                        $q.all([loadOtherActivities(), self.ResourcePool.load()])
                          .then(function () {
                              loadingModal.dismiss();

                              if (nextAction) {
                                  nextAction();
                              }

                          });

                        FlashService.Success(result.data.message);
                    } else {
                        loadingModal.dismiss();
                    }
                });

            };

            self.cancelOtherActivitiesDurationChanges = function (nextAction) {

                var cancelOtherActivitiesDurationChangesAction = function () {

                    self.otherActivities.activities.forEach(function (group) {

                        var originalGroup = self.otherActivitiesOriginal.activities.firstOrDefault(function (original) {
                            return original.name === group.name;
                        });

                        if (originalGroup) {

                            group.items.forEach(function (activity) {

                                var originalActivity = originalGroup.items.firstOrDefault(function (item) {
                                    return item.scheduleId === activity.scheduleId;
                                });

                                if (originalActivity && activity.totalDuration !== originalActivity.totalDuration) {
                                    activity.totalDuration = originalActivity.totalDuration;
                                }
                            });

                            group.groupingSummaries = getGroupingStaffSummaries(group);
                        }
                    });

                    setViewMode();

                    if (nextAction) {
                        nextAction();
                    }

                };

               
                cancelOtherActivitiesDurationChangesAction();
                setViewMode();
        

            };

            self.resetOtherActivitiesDurationChanges = function (type) {

                var request = context.getViewModeSelectedDateAndLocation();
                request.scheduleIds = [];

                self.otherActivities.activities.forEach(function (facilityActivityGroup) {

                    facilityActivityGroup.items.forEach(function (item) {
                        request.scheduleIds.push(item.scheduleId);
                    });
                });

                request.activityResetAction = type;

                var loadingModal = FlashService.Loading();
                DailyPlanService.ResetLocationActivities(request).then(function () {
                    reloadView(loadingModal);
                });
            };

            self.processGridRowAction = function (action, item) {
                var data = {};
                data.activityActionType = action.value;
                data.scheduleIds = [item.scheduleId];
                //data.facilityCode = item.facilityCode.trim();
                data.date = moment(context.TopBar.dateDisplayed).startOf('day');
                //activity Type==Other activity
                data.activityType = 1;
                var sendGridRowAction = function () {

                    var loadingModal = FlashService.Loading();
                    DailyPlanService.SetGridRowActions(data).then(function (result) {

                        $q.all([loadOtherActivities(), self.ResourcePool.load()])
                          .then(function () {
                              loadingModal.dismiss();
                          });

                        FlashService.Success(result.data.message);
                    }).finally(function () {
                        loadingModal.dismiss();
                    });
                };

                switch (action.name) {
                    case 'Cancel Activity':
                        var confirmationMessage = self.doesActivityStatusAllowActivityChanging(item.activityStatusId) ? "Are you sure you want to cancel this activity?" : "This activity has already been marked " + item.activityStatus + ". Are you sure you want to cancel this activity?";

                        DailyPlanConfirmationService.YesNoConfirmation(confirmationMessage, null, { title: 'Cancel Activity', no: 'Never mind', yes: 'Yes, Cancel Activity' })
                                   .Yes(sendGridRowAction)
                                   .Ask();

                        break;
                }
            };

            self.isThereNoFacilityOrArea = function () {
                return !self.otherActivities || (!self.otherActivities.activities ||
                         self.otherActivities.activities.length === 0 ||
                         self.otherActivities.activities[0].items.length === 0);
            };

            self.showCancelledActivitiesDialog = function (cancelledActivities) {

                var data = {
                    cancelledActivities: cancelledActivities,
                    date: moment(context.TopBar.dateDisplayed).startOf('day'),
                    isPastDateDisplayed: context.TopBar.isPastDateDisplayed()
                };

                var popup = Utils.OpenModal('', 'ng1/src/dailyPlan/views/dialogs/cancelledActivitiesDialog.html', 'cancelledActivitiesController', data, 'daily-plan-cancelled-activities-dialog', null, false);

                popup.result.then(function (reload) {
                    if (reload) {
                        var loadingModal = FlashService.Loading();
                        $q.all([loadOtherActivities(), self.ResourcePool.load()])
                            .then(function () {
                                loadingModal.dismiss();
                            });
                    }

                    popup.dismiss();
                });
            };

            self.defaultDndTargets = function () {
                self.ResourcePool.dndTarget = [];

                if (self.otherActivities.activities) {
                    self.otherActivities.activities.forEach(function (group) {
                        group.dndTarget = [];

                        if (group.items) {
                            group.items.forEach(function (item) {
                                if (self.doesActivityStatusAllowActivityChanging(item.activityStatusId)) {
                                    item.dndTarget = [];
                                    item.dndType = group.name;
                                }
                            });
                        }
                    });
                }

                if (self.otherActivities.activities.assigneeStatistics) {
                    self.otherActivities.activities.assigneeStatistics.dndTarget = [];
                }
            };

            self.filterPresentStaffByRoomSpecies = function (activity) {

                self.ResourcePool.Filter.ByActivityFilter.selectedItems = self.ResourcePool.Filter.ByActivityFilter.selectedItems.filter(m => m.id !== activity.activityId);
                self.ResourcePool.Filter.ByActivityFilter.selectedItems.push({ id: activity.activityId, value: activity.activity });

                if (!self.showResourcePool) {
                    self.toggleResourcePool();
                }

                self.ResourcePool.performFiltering();
            };

            self.doesActivityStatusAllowActivityChanging = function (activityStatusId) {
                return activityStatusId === Constants.ActivityStatus.NotStarted || activityStatusId === Constants.ActivityStatus.Lapsed;
            };

            self.openStaffNoteEditing = function (activity, groupName) {

                var data = {
                    selectedActivity: activity,
                    groupName: groupName
                };

                Utils.OpenModal('', 'ng1/src/dailyPlan/views/dialogs/staffNotesDialog.html', 'staffNotesController', data, 'staff-notes-dialog', null, false);
            };

            function getOnLeaveConfirmMessage() {

                if (self.EditMode || self.isActivitiesGridChanged()) {
                    return "Save pending duration changes?";
                }

                return "";
            }

            function isActivitiesGridChanged() {

                if (self.otherActivities && self.otherActivities.activities) {

                    return self.otherActivities.activities.some(function (group) {

                        var originalGroup = self.otherActivitiesOriginal.activities.firstOrDefault(function (original) {
                            return original.name === group.name;
                        });

                        if (originalGroup) {

                            return group.items.some(function (activity) {

                                var originalActivity = originalGroup.items.firstOrDefault(function (item) {
                                    return item.scheduleId === activity.scheduleId;
                                });

                                if (originalActivity) {
                                    return activity.totalDuration !== originalActivity.totalDuration;
                                }

                                return false;
                            });
                        }

                        return false;
                    });
                }

                return false;
            }

            function saveRightPanesState() {
                sessionStorage.showDailyPlanStatisticsPane = self.showStatistics || "";
                sessionStorage.showDailyPlanResourcePoolPane = self.showResourcePool || "";
                sessionStorage.showDailyPlanNonDailyActivitiesPane = self.showNonDailyActivities || "";
            }

            function setViewMode() {
                self.EditMode = false;
            }

            function setEditMode() {
                self.EditMode = true;
            }

            function getGroupingStaffSummaries(group) {
                var uniqueIds = Array.from(new Set(group.items.map(function (item) { return item.assignmentId; })));
                var groupedItems = [];

                uniqueIds.forEach(function (id) {
                    if (id !== null && id !== undefined) {
                        groupedItems.push(group.items.filter(function (item) { return item.assignmentId === id; }));
                    }
                });

                var groupingSummary = [];

                groupedItems.forEach(function (groupingItem) {
                    groupingSummary.push({
                        assigneeId: groupingItem[0].assignmentId ? groupingItem[0].assignmentId : null,
                        assigneeName: groupingItem[0].assignment ? groupingItem[0].assignment : null,
                        totalActivityDurations: groupingItem.sumOf('totalDuration'),
                        hasChangeableActivities: (groupingItem.filter(function (item) { return self.doesActivityStatusAllowActivityChanging(item.activityStatusId); }).length > 0) ? true : false
                    });
                });

                return groupingSummary;
            }

            function loadStatistics() {

                var deferred = $q.defer();
                var request = context.getViewModeSelectedDateAndLocation();

                self.statisticChanging = true;
                DailyPlanService.GetDetailsStatistics(request).then(function (result) {

                    if (result.success) {
                        self.statistic = result.data;
                    }

                    self.statisticChanging = false;
                    deferred.resolve();
                });

                return deferred.promise;
            }

            function getAssigneeStatistics(locationActivities) {
                var allGroupedAssignees = [];

                locationActivities.forEach(function (locationActivity) {
                    locationActivity.groupingSummaries.forEach(function (groupingSummary) {
                        allGroupedAssignees.push(groupingSummary);
                    });
                });

                var assigneeGroupedStats = Array.from(new Set(allGroupedAssignees.map(function (assignee) {
                    return {
                    assigneeId: assignee.assigneeId,
                    assigneeName: assignee.assigneeName,
                    totalActivityDurations: assignee.totalActivityDurations
                };
                })));

                var uniqueAssigneeGroupedStatsIds = Array.from(new Set(assigneeGroupedStats.map(function (assignee) {
                    return assignee.assigneeId;
                })));

                var uniqueAssigneeGroupedStats = [];

                uniqueAssigneeGroupedStatsIds.forEach(function (id) {
                    if (id !== null && id !== undefined) {
                        uniqueAssigneeGroupedStats.push(allGroupedAssignees.filter(function (assignee) { return assignee.assigneeId === id; }));
                    }
                });

                var assigneeStatistics = [];

                uniqueAssigneeGroupedStats.forEach(function (assignee) {
                    assigneeStatistics.push({
                        assigneeId: assignee[0].assigneeId,
                        assigneeName: assignee[0].assigneeName,
                        totalActivityDurations: assignee.sumOf('totalActivityDurations'),
                        hasChangeableActivities: assignee[0].hasChangeableActivities
                    });
                });

                return assigneeStatistics;
            }

            function reloadView(loadingModal) {

                loadingModal = loadingModal || FlashService.Loading();

                $q.all([loadOtherActivities(), self.ResourcePool.load()])
                  .then(function () {
                      loadingModal.dismiss();
                  });
                self.NonDailyActivities.load();
            }

            function loadOtherActivities() {

                var deferred = $q.defer();
                var request = context.getViewModeSelectedDateAndLocation();

                DailyPlanService.GetOtherActivities(request).then(function (result) {

                    if (result.success) {
                        self.otherActivities = {
                            activities: result.data.otherActivities,
                            cancelledOtherActivities: result.data.cancelledOtherActivities
                        };

                        self.otherActivities.activities.forEach(function (group) {

                            group.items.forEach(function (activity) {
                                activity.elementClassName = ElementIdHelper.getActivityElementClassName(activity.scheduleId, activity.activityStatusId);
                            });

                            group.hasChangeableActivities = (group.items.filter(function (item) { return self.doesActivityStatusAllowActivityChanging(item.activityStatusId); }).length > 0) ? true : false;
                            group.groupingSummaries = getGroupingStaffSummaries(group);
                            group.expanded = true;
                        });

                        self.otherActivities.activities.assigneeStatistics = getAssigneeStatistics(self.otherActivities.activities);



                        self.defaultDndTargets();

                        self.otherActivities.activities.hasChangeableActivities = (self.otherActivities.activities.filter(function (group) { return group.hasChangeableActivities === true; }).length > 0) ? true : false;

                        self.otherActivitiesOriginal = angular.copy(self.otherActivities);
                    }

                    deferred.resolve();
                });

                return deferred.promise;
            }

            function isDraggingAllowed() {

                if (self.EditMode) {
                    FlashService.Error('Please save or cancel duration changes before changing assignments.');
                    return false;
                }

                return true;
            }

            function onEndDragging() {

                if (SignalR.IsSupported()) {
                    self.defaultDndTargets();
                } else {
                    reloadView();
                }
            }

            function initialize() {
                self.ResourcePool = new DailyPlanResourcePool(context);
                self.NonDailyActivities = new NonDailyActivities(context);
                self.DragActivitySequence = new DragActivitySequence(context);

                self.DragFromResourcePool = new DragFromRPToOtherActivities(self);
                self.DragFromResourcePool.onStartDragging(function () {
                    return isDraggingAllowed();
                });

                self.DragFromResourcePool.onEndDragging(onEndDragging);

                self.DragStaffIntoResourcePool = new DragStaffIntoResourcePool(context);

                self.DragToResourcePool = new DraggingToResourcePoolActions([self.DragStaffIntoResourcePool]);
                self.DragToResourcePool.onEndDragging(onEndDragging);
                self.DragToResourcePool.onStartDragging(function () {

                    if (isDraggingAllowed()) {

                        if (!self.showResourcePool) {
                            self.toggleResourcePool();
                        }

                        self.ResourcePool.selectPresentStaffTab();

                        return true;
                    }

                    return false;
                });

                self.EditMode = false;

                self.showStatistics = sessionStorage.showDailyPlanStatisticsPane ? true : false;
                self.showResourcePool = sessionStorage.showDailyPlanResourcePoolPane ? true : false;
                self.showNonDailyActivities = sessionStorage.showDailyPlanNonDailyActivitiesPane ? true : false;

                if (self.showStatistics && self.showResourcePool) {
                    self.showStatistics = false;
                }
                if (self.showNonDailyActivities && self.showResourcePool) {
                    self.showNonDailyActivities = false;
                }
            }

            initialize();
        }

        return (OtherActivitiesViewModel);

    }]);
